import { httpClient } from '@/shared/services/HttpClient';

class UserSettingsService {
  url = 'usersystem/usersettings';

  get(): any {
    return httpClient.get(this.url);
  }

  update(form: any): any {
    return httpClient.post(this.url, form);
  }
}

const userSettingsService = new UserSettingsService();

export { userSettingsService };
